import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import ArticleTagLink from "./article-tag-link"
import * as styles from "./article-tag-list.module.scss"


export default function ArticleTagList({ selectedTag }) {
  const { wagtailbase } = useStaticQuery(query)
  const articleTags = wagtailbase.articleTags;
  return (
    <section className={styles.articleTagListContainer}>
      {articleTags.map(tag => {
          const isSelected = (tag.slug === selectedTag?.slug) ? true : false
          return <ArticleTagLink articleTag={tag} isSelected={isSelected} key={tag.slug} />
      })}
    </section>
  )
}

const query = graphql`
  query {
    wagtailbase {
      articleTags {
        name
        slug
      }
    }
  }
`
